import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, PlatformLocation } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ReferralBannerService {
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  private readonly platformLocation = inject(PlatformLocation);

  isReferralVisitor(): boolean {
    if (!this.isBrowser) {
      return false;
    }

    const params = new URLSearchParams(this.platformLocation.search);

    const hc = params.get('hc');
    if (hc && hc.toUpperCase().includes('AMBREFERRAL')) {
      return true;
    }

    if (params.get('couponAmbassador')) {
      return true;
    }

    if (params.get('couponAmbassadorRSA')) {
      return true;
    }

    return false;
  }
}
